import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class GetUnitExternalReferencesFailedError extends CodedError {
  static get errorName() {
    return errorCodeTypes.getUnitExternalReferencesFailedError.code;
  }

  constructor(
    message = errorCodeTypes.getUnitExternalReferencesFailedError.message
  ) {
    super(message);
    this.code = errorCodeTypes.getUnitExternalReferencesFailedError.code;
    this.message = `${message} ${errorCodeTypes.getUnitExternalReferencesFailedError.code}`;
    this.name = errorCodeTypes.getUnitExternalReferencesFailedError.name;
  }
}
